const SAMPLE_TRANSCRIPT = [
	"Let's start with the Country Finder follow-up from last session.",
	'Student is leaning toward UCLA for Computer Science because of ranking and flexibility.',
	'Parents are still concerned about overall cost and scholarship clarity.',
	'UCSD aid looks stronger by roughly eight thousand dollars each year.',
	'Need a cleaner comparison before the next conversation.',
	'Student also wants a simpler shortlist for scholarships and essay deadlines.',
]

const SECONDS_PER_SENTENCE = 5

/**
 * Phase-1 stand-in for live STT. Writes transcript text via injected onUpdate callback.
 * Replace with a real STT provider in a later phase without changing the store API.
 */
export function createMockTranscriptProvider({ onUpdate }) {
	let disposed = false

	const notify = text => {
		if (disposed) return
		onUpdate?.(text)
	}

	return {
		startRecording() {
			disposed = false
			notify('')
		},

		handleChunk() {},

		handleStop() {},

		async flush() {},

		reset() {
			disposed = false
			notify('')
		},

		sync(elapsedSeconds) {
			if (disposed) return

			const visibleCount = Math.min(
				SAMPLE_TRANSCRIPT.length,
				Math.max(1, Math.floor(elapsedSeconds / SECONDS_PER_SENTENCE) + 1),
			)
			notify(SAMPLE_TRANSCRIPT.slice(0, visibleCount).join(' '))
		},

		dispose() {
			disposed = true
		},
	}
}
